export default __webpack_public_path__ + "static/media/atm.10c33722.png";